import { createAction, props } from '@ngrx/store';
import { MENU_COMEDOR_SEDE, MenuComedorSedeRecord } from 'src/common/menuComedor';


export const menuComedorRequested = createAction( '[MenuComedor Component] Menu Comedor Requested' );
export const menuComedorLoaded = createAction( '[MenuComedor API] Menu Comedor Loaded', props<{ menus: MenuComedorSedeRecord[], sedesWithoutMenu: MENU_COMEDOR_SEDE[] }>() );
export const menuComedorCancelled = createAction( '[MenuComedor API] Menu Comedor Cancelled', props<{ clear?: MENU_COMEDOR_SEDE[] | true }>() );
export const menuComedorSedeChanged = createAction( '[MenuComedor Component] Menu Comedor Sede Selected', props<{ sedeSelected: MENU_COMEDOR_SEDE }>() );
